import React from "react";
import "./styles.scss";
import { saveAs } from "file-saver";
import DSOButton from "../../UI/button/DSOButton";
import { IoDocumentOutline } from "react-icons/all";

const Index = ({ option, item }) => (
  <>
    <div className={`inner__application-summary-wrp   d-flex justify-content-between  ${option}`}>
      <div className={"left d-flex  align-items-center"}>
        <div className={"doc-icon"}>
          <IoDocumentOutline className="icon" />
        </div>
        <div className={"d-flex"}>
          <div className={"doc-text"}>{item.Title}</div>
          <div className={"doc-type-tag"}>PDF</div>
        </div>
      </div>

      <div className={"right ml-2"}>
        <div className={`v-d-btn d-flex align-items-center `}>
          <a href={item.ItemUrl} target="_blank" rel="noreferrer noopener" className="view-btn-link">
            <DSOButton text="View" btnType="back" className="view-btn" />
          </a>
          <DSOButton
            className="download-btn"
            text="Download"
            btnType="next"
            onClick={() => {
              saveAs(item.ItemUrl, `${item.Title}.pdf`);
            }}
          />
        </div>
      </div>
    </div>
  </>
);
export default Index;
